<template>
    <div class="footerBar">
        <span class="footer__text"> © True Software Scandinavia AB</span>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.footerBar{
    background-color:#001049;
    height:4rem;
    padding:20px 0px 0px 100px;
}
.footer__text{
    color:#d1d8d9;
}
</style>